import moment from 'moment';

export const unnormalStatusOption = [
  { label: '全部', value: -1, content: '全部', key: -1 },
  { label: '是', value: 1, content: '是', key: 1 },
  { label: '否', value: 0, content: '否', key: 0 },
];
export const statusOption = [
  {
    label: '全部',
    value: -1,
    content: '全部',
    key: -1,
  },
  {
    label: '待取餐',
    value: 100,
    content: '待取餐',
    key: 100,
  },
  {
    label: '已取餐',
    value: 200,
    content: '已取餐',
    key: 200,
  },
  {
    label: '待放餐',
    value: 300,
    content: '待放餐',
    key: 300,
  },
  {
    label: '已完成',
    value: 400,
    content: '已完成',
    key: 400,
  },
  {
    label: '待指派',
    value: 50,
    content: '待指派',
    key: 50,
  },
  {
    label: '待中转',
    value: 500,
    content: '待中转',
    key: 500,
  },
  {
    label: '已中转',
    value: 600,
    content: '已中转',
    key: 600,
  },
  {
    label: '已取消',
    value: 401,
    content: '已取消',
    key: 401,
  },
];
export const otherStatusOption = [
  {
    label: '全部',
    value: -1,
    content: '全部',
    key: -1,
  },
  {
    label: '已取消',
    value: 10,
    content: '已取消',
    key: 10,
  },
  {
    label: '已到店',
    value: 100,
    content: '已到店',
    key: 100,
  },
  {
    label: '已取餐',
    value: 200,
    content: '已取餐',
    key: 200,
  },
  {
    label: '已完成',
    value: 400,
    content: '已完成',
    key: 400,
  },
];
// 商家订单
export const shopStatusOption = [
  {
    label: '全部',
    value: -1,
    content: '全部',
    key: -1,
  },
  {
    label: '待取餐',
    value: 100,
    content: '待取餐',
    key: 100,
  },
  {
    label: '已取餐',
    value: 200,
    content: '已取餐',
    key: 200,
  },
  {
    label: '待放餐',
    value: 300,
    content: '待放餐',
    key: 300,
  },
  {
    label: '已完成',
    value: 400,
    content: '已完成',
    key: 400,
  },
  {
    label: '已取消',
    value: 10,
    content: '已取消',
    key: 10,
  },
];
// 商家订单异常状态
export const unusualOrderStatusOption = [
  { label: '全部', value: -1, content: '全部', key: -1 },
  { label: '是', value: 1, content: '是', key: 1 },
  { label: '否', value: 0, content: '否', key: 0 },
];
export const hasAcceptOptions = [
  { label: '全部', value: '', content: '全部', key: '' },
  { label: '是', value: 1, content: '是', key: 1 },
  { label: '否', value: 0, content: '否', key: 0 },
];

// 订单类型
export const orderTypeOption = [
  {
    label: '全部',
    value: -1,
    content: '全部',
    key: -1,
  },
  {
    label: '正常取餐',
    value: 0,
    content: '正常取餐',
    key: 0,
  },
  {
    label: '配前售后',
    value: 11001,
    content: '配前售后',
    key: 11001,
  },
  {
    label: '配前取消',
    value: 21002,
    content: '配前取消',
    key: 21002,
  },
  {
    label: '配前售后拒绝',
    value: 11003,
    content: '配前售后拒绝',
    key: 11003,
  },
  {
    label: '配前售后同意',
    value: 31005,
    content: '配前售后同意',
    key: 31005,
  },
  {
    label: '配中售后',
    value: 2001,
    content: '配中售后',
    key: 2001,
  },
  {
    label: '配中取消/售后同意',
    value: 22002,
    content: '配中取消/售后同意',
    key: 22002,
  },
  {
    label: '接驳后售后',
    value: 3001,
    content: '接驳后售后',
    key: 3001,
  },
  {
    label: '接驳后取消/售后同意',
    value: 23002,
    content: '接驳后取消/售后同意',
    key: 23002,
  },
  {
    label: '放餐后售后',
    value: 4001,
    content: '放餐后售后',
    key: 4001,
  },
  {
    label: '放餐后取消/售后同意',
    value: 24002,
    content: '放餐后取消/售后同意',
    key: 24002,
  },
];
// 订单类型
export const orderTypeOptionTable = [
  {
    label: '全部',
    value: -1,
    content: '全部',
    key: -1,
  },
  {
    label: '正常取餐',
    value: 0,
    content: '正常取餐',
    key: 0,
  },
  {
    label: '配前售后',
    value: 11001,
    content: '配前售后',
    key: 11001,
  },
  {
    label: '配前售后',
    value: 1001,
    content: '配前售后',
    key: 1001,
  },
  {
    label: '配前取消',
    value: 11002,
    content: '配前取消',
    key: 11002,
  },
  {
    label: '配前取消',
    value: 21002,
    content: '配前取消',
    key: 21002,
  },
  {
    label: '配前售后拒绝',
    value: 11003,
    content: '配前售后拒绝',
    key: 11003,
  },
  {
    label: '配前售后拒绝',
    value: 1003,
    content: '配前售后拒绝',
    key: 1003,
  },
  {
    label: '配前售后同意',
    value: 11005,
    content: '配前售后同意',
    key: 11005,
  },
  {
    label: '配前售后同意',
    value: 31005,
    content: '配前售后同意',
    key: 31005,
  },
  {
    label: '配中售后',
    value: 2001,
    content: '配中售后',
    key: 2001,
  },
  {
    label: '配中取消/售后同意',
    value: 22002,
    content: '配中取消/售后同意',
    key: 22002,
  },
  {
    label: '配中取消/售后同意',
    value: 32005,
    content: '配中取消/售后同意',
    key: 32005,
  },
  {
    label: '接驳后售后',
    value: 3001,
    content: '接驳后售后',
    key: 3001,
  },
  {
    label: '接驳后取消/售后同意',
    value: 23002,
    content: '接驳后取消/售后同意',
    key: 23002,
  },
  {
    label: '接驳后取消/售后同意',
    value: 33005,
    content: '接驳后取消/售后同意',
    key: 33005,
  },
  {
    label: '放餐后售后',
    value: 4001,
    content: '放餐后售后',
    key: 4001,
  },
  {
    label: '放餐后取消/售后同意',
    value: 24002,
    content: '放餐后取消/售后同意',
    key: 24002,
  },
  {
    label: '放餐后取消/售后同意',
    value: 34005,
    content: '放餐后取消/售后同意',
    key: 34005,
  },
];
// 售后状态异常
export const afterSaleUnnormalOption = [
  { label: '全部', value: -1, content: '全部', key: -1 },
  { label: '是', value: 1, content: '是', key: 1 },
  { label: '否', value: 0, content: '否', key: 0 },
];

// 调度类型
export const taskTypeMap = ['直送', '中转'];

export const defaultFilterState = {
  page: 1,
  pageSize: 10,
  deliveryTime: [moment().subtract(6, 'days').startOf('days'), moment().endOf('days')],
  groupOrderId: '',
  shopId: '',
  shopName: '',
  sendEmployeeName: '',
  acceptEmployeeName: '',
  status: -1,
  unnormalStatus: -1,
  cityName: undefined,
  cbdId: undefined,
  deliveryMethod: 0,
  transferStationEmployeeName: '',
  taskType: 0,
  saasAgentId: null,
  showTest: 0,
};
